<div class="flex">
  @for (data of datalist; track data) {
    <div class="mr-2 relative">
      <div
        class="relative border rounded border-solid border-gray-300 flex px-2 py-1"
        [ngClass]="{ 'rounded-b-none': data.drpdownOpen }"
        >
        <span
          class="flex justify-center items-center font-semibold mr-2"
          [title]="data.toolTip"
          >{{ data.key }}:
        </span>
        @for (val of data.displayValue; track val) {
          <div
            class="flex justify-center items-center"
            >
            <span
          [ngClass]="{
            'block overflow-hidden overflow-ellipsis whitespace-nowrap max-w-xs':
              data.displayValue && data.displayValue.length > 1
          }"
              [title]="val"
              >{{ val }}</span
              >
              @if (data.value && data.value.length > 1) {
                <img
                  class="float-right mt-1 ml-1 mr-1"
                  src="assets/images/cross.svg"
                  (click)="onDeleteValue(data, val)"
                  />
              }
            </div>
          }
          @if (data.otherValues && data.otherValues.length > 0) {
            <span
              (click)="toggleDropdown(data)"
              class="flex items-center"
              >
              @if (!data.drpdownOpen) {
                <img
                  class="h-2"
                  src="assets/images/expand-blue.svg"
                  />
              }
              @if (data.drpdownOpen) {
                <img
                  class="h-2"
                  src="assets/images/collapse-blue.svg"
                  />
              }
            </span>
          }
        </div>
        @if (data.drpdownOpen) {
          <div
            class="absolute grid grid-cols-3 border border-t-0 border-gray-300 py-0 px-2 z-10 opacity-100 bg-white overflow-y-auto max-h-24 w-full"
            >
            @for (val of data.otherValues; track val) {
              <div>
                <span
                  class="w-4/6 overflow-hidden overflow-ellipsis inline-block whitespace-nowrap"
                  [title]="val"
                  >{{ val }}</span
                  >
                  @if (data.value && data.value.length > 1) {
                    <img
                      class="float-right mt-1 mr-1"
                      src="assets/images/cross.svg"
                      (click)="onDeleteValue(data, val)"
                      />
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
